import { render, staticRenderFns } from "./FPageSales.vue?vue&type=template&id=3beda405&"
import script from "./FPageSales.vue?vue&type=script&lang=js&"
export * from "./FPageSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports